import { useState } from "react";
import { Outlet, useOutletContext } from "react-router-dom";

import LeftNav from "./LeftNav";

type ShowNavFunction = (showNav: boolean) => void;

export const useMobileNavOutletContext = () =>
  useOutletContext<{
    showMobileNav: boolean;
    setShowMobileNav: ShowNavFunction;
  }>();

export const useMobileNavContext = () => {
  const { showMobileNav, setShowMobileNav } = useMobileNavOutletContext();
  return {
    isMobileNavOpen: showMobileNav,
    openMobileNav: () => setShowMobileNav(true),
    closeMobileNav: () => setShowMobileNav(false),
  };
};

const Layout = () => {
  const [showMobileNav, setShowMobileNav] = useState(false);
  return (
    <div className="flex h-dvh flex-col lg:flex-row" data-component="Layout">
      <div
        className={`${
          showMobileNav ? "absolute" : "hidden"
        } lg:block lg:w-1/6 w-10/12 max-w-xs h-full z-30`}
      >
        <LeftNav
          showMobileNav={showMobileNav}
          closeMobileNav={() => setShowMobileNav(false)}
        />
      </div>
      <div
        className="lg:w-5/6 flex-grow w-full"
        style={{
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <Outlet context={{ showMobileNav, setShowMobileNav }} />
      </div>
    </div>
  );
};

export default Layout;
